<template lang="pug">
  .py-30.px-50.text-left
    .font-700.text-24 {{$t('__d8.__applicationDownload')}}

    hr.border-t-2.my-16

    .mt-28(v-if="downloadData.length")
      .py-8.px-20.mb-12.flex.justify-between.items-center.bg-grey-f7.cursor-pointer.rounded-10(v-for="(e, i) in downloadData")
        span.align-middle {{e.name}} {{e.version}}
        .flex.justify-start.items-center
          .mr-16 {{e.time}}
          .top-28.right-36.flex.items-center.justify-center.cursor-pointer(@click="downloadApp(e)")
            iCon.h-24.w-24.text-main-0(:iconClass="'Ico_Download'" type="svg" )
            //- .text-12.ml-6 Download

    .mb-115(v-if="!downloadData.length && localLoading")
      .w-144.h-144.m-auto
        img.w-full( src='@/assets/Default.png')
      .mt-40.w-240.text-center.m-auto.text-16 {{$t('__d8.__loadingText')}}
    .mb-115(v-if="errorList ")
      .w-144.h-144.m-auto
        img.w-full( src='@/assets/Default.png')
      .mt-40.w-240.text-center.m-auto.text-16.font-600.text-grey-9E {{$t('__e5H7.__errorText')}}

    
    Pagination.mt-56(
        v-if="downloadData.length"
        :totalPage="meta.total_page" 
        :nowPage="meta.current" 
        :range="range" 
        @changePage="changePage" 
        position="center")




    
          

</template>

<script>


import moment from 'moment';

import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import Select from '@/components/Select.vue';
import TableBar from '@/components/TableBar.vue';
import TableEach from '@/components/TableEach.vue';
import Pagination from '@/components/Pagination.vue';
import Modal from '@/components/Modal.vue';

import { ENV } from '@/enum/global';
import {  encodeHTML } from '@/utils/xxsConfig.js';
import {  dynamicLink } from "@/api/users.js";
import { getApplication } from "@/api/download.js";

export default {
  name: 'Download',
  components: {
    Button,
    Input,
    Select,
    TableBar,
    TableEach,
    Pagination,
    Modal,
  },
  data(){
    return {
      localLoading: false,
      meta: {  //Pagination data
        current:1,
        total: 0,
        total_page: 0,
        page_size: 10,
      },
      updateBehavior: {
        id: '1',
        name: '30 d',
      },
      apiError: null, //個別頁面的api error handler
      downloadData:[],
      updateBehaviorOption:[
        {id: '1',
          name: '30 d',
        },
        {id: '2',
          name: '90 d',
        },
        {id: '3',
          name: '1 Y',
        },
      ],
      errorList: false,
    }
  },
  // mixins: [ npsSetting],
  async created(){

  },
  async mounted(){
    await this.getApplicationList()



  },
  methods:{
    async getApplicationList(){
      
      let sendData = {
        page_size: this.meta.page_size,
        page : this.meta.current,
      }
      try{
        const {data } = await getApplication(sendData);
        if(data){
          this.errorList = false;
          if(data.results.length){
            for (let i = 0; i < data.results.length; i++) {
              data.results[i]['time'] = moment(data.results[i].release_date.replace(/ /g, ""), moment.ISO_8601).format('YYYY/MM/DD'); 
            }
            
          }else{
            this.localLoading = true;
          }
          this.downloadData = data.results
          this.meta.total = data.count;
          this.meta.total_page = Math.ceil(data.count/this.meta.page_size);
          this.meta.current = data.current;
        
        }
      } catch(error){
        this.errorList = true;
        // this.apiError = error.response.status;
      }

    },
    changeStep(e){
      // console.log(e)
      this.currentStep = e.index
    },
    selectFrequency(){

    },
    toblur(){

    },
    getLink(){

    },
    async changePage(page){
      this.meta.current = page;
    },
    async downloadApp(e){
      if(process.env.VUE_APP_ENV == ENV.UAT  || process.env.VUE_APP_ENV == ENV.PRODUCTION){
        try{
          await dynamicLink(e.link);
          console.log('env pro link',e);
          this.downloadFile(e.link)
        }
        catch (error) {
          // this.apiError = error.response.status;
        }
      }else{
        console.log('env local')
        // this.$store.commit('modal/setIsDownload', true);
        this.downloadFile(e.link)
      }
    },
    async downloadFile(url) {
      let clean = encodeHTML(url) //安全性轉

      const iframe = document.createElement("iframe");
      iframe.sandbox="allow-downloads"
      iframe.style.display = "none"; // 防止影響頁面
      iframe.style.height = 0; // 防止影響頁面
      iframe.src = clean; 
      document.body.appendChild(iframe); 
      setTimeout(()=>{
        iframe.remove();
      }, 5 * 60 * 1000);
    },

    
    // ...mapMutations({
          // setSinglePageAlert: 'modal/setSinglePageAlert',  // show modal
    // }),
    


    
  },
  watch:{
    '$store.state.user.user': function() {
    }
  },
  computed:{
    historyColumn(){ //driver packs 的欄位title
      return [
        {
          title: 'Frequency',
          key: "frequency",
        },
        {
          title: 'Update Behavior',
          key: "updateBehavior",
        },
        {
          title: 'Severity',
          key: "severity",
        },
        {
          title: 'Category',
          key: "category",
        },
      ]
    },
    range() {
      return this.meta.total_page < 5 ? this.meta.total_page : 5;
      // return this.meta.total_page;
    },
  }

}
</script>

<style lang="scss" scoped>


</style>
